<div class="w-full h-full text-lg flex justify-center items-center">
    <button (click)="logOut()">
        <fa-icon [icon]="logout"></fa-icon>
    </button>

</div>


